// @flow

import * as React from 'react';

import { Select, type SelectProps } from '@gandi/form';
import { useTranslator } from '@gandi/translate';

import styles from './SelectLangRow.scss';

type Props = {
  values: SelectProps['values'],
  name: string,
  title: string,
  value: string,
  handleChange: (SyntheticInputEvent<>) => void,
};

const selectVariant = ['small', 'block'];

function SelectLangRow({ values, handleChange, name, value, title }: Props) {
  const { __ } = useTranslator();

  return (
    <Select
      className={styles.selectLang}
      value={value}
      values={values}
      variant={selectVariant}
      title={title}
      onChange={handleChange}
      placeholder={__('Select a language')}
      name={name}
    />
  );
}

export default (React.memo<Props>(SelectLangRow): React.ComponentType<Props>);
